import { graphql } from "@/lib/gql/__generated__";

export const SendCustomMailSettingMutationForReservationCreate = graphql(/* GraphQL */ `
	mutation testCustomMailSendAtReservationCreate($input: CustomMailSettingTestMailInput!) {
		testCustomMailSendAtReservationCreate(input: $input) {
			userErrors
			success
		}
	}
`);
